import { Component } from '@angular/core';
import * as $ from 'jquery'
@Component({
    selector: "page-tramites",
    templateUrl: "./tramites.component.html"
})

export class TramitesComponent {
    constructor(){
        $(document).ready(() => {
            $('[id^=detail-]').hide();
            $('.toggle').click(function() {
                var input = $( this );
                var target = $('#'+input.attr('data-toggle'));
                target.slideToggle();
            });	
        }) 

    }
}